import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Event, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { PageLoaderComponent } from './layout/page-loader/page-loader.component';
import { NgxPhotoEditorModule } from "ngx-photo-editor";
import { LightboxComponent } from "./shared/components/lightbox/lightbox.component";
import { LoaderComponent } from "./shared/components/loader/loader.component"
import { AuthService } from '@core';
declare var FsLightbox: any;
@Component({
  selector: 'app-root',
  standalone: true,
  providers: [],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, RouterModule, PageLoaderComponent, LightboxComponent, LoaderComponent ]
})
export class AppComponent {
  currentUrl!: string;
  constructor(public _router: Router,private authService:AuthService) {
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        /* empty */
      }
      window.scrollTo(0, 0);
    });
  }

//   ngOnInit() {
//     const rememberMe = localStorage.getItem("remember_me");
//     const sessionExpiry = sessionStorage.getItem("session_expiry");




//     if (!rememberMe && sessionExpiry) {
      

//         console.log("Browser closed and Remember Me was not checked, clearing session.");

       
//         localStorage.removeItem("currentUser");
//         localStorage.removeItem("refresh_token");

//         sessionStorage.removeItem("session_expiry");



  
//         this.authService.logout();
//     }

 
// }
ngOnInit() {
  // const rememberMe = localStorage.getItem("remember_me");


  // const sessionExpiry = sessionStorage.getItem("session_expiry");

  // console.log("Session Expiry on Init:", sessionExpiry);
  // console.log("Remember Me on Init:", rememberMe);

 
  // if (!sessionExpiry && !rememberMe) {
  //     console.log("Browser restarted, Remember Me was not checked. Logging out...");
  //     localStorage.removeItem("currentUser");
  //     localStorage.removeItem("refresh_token");

  //     this.authService.logout();
  //     return;
  // }


  // if (rememberMe) {
  //     console.log("Remember Me enabled, keeping the session active.");
  //     return;
  // }

  // if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
  //     console.log("Browser refreshed, keeping session active.");
  //     return;
  // }


  // const sessionActive = sessionStorage.getItem("session_active");

  // if (!rememberMe && sessionExpiry) {
  //     if (sessionActive) {
  //         console.log("Browser was refreshed, keeping the session active.");
  //         return; 
  //     }

  //     console.log("Browser closed and Remember Me was not checked, clearing session.");

  //     localStorage.removeItem("currentUser");
  //     localStorage.removeItem("refresh_token");

  //     sessionStorage.removeItem("session_expiry");
  //     sessionStorage.removeItem("session_active");

  //     this.authService.logout();
  // }

  // sessionStorage.setItem("session_active", "true");
}
  ngAfterViewInit() {
    // Initialize fslightbox after the view has been initialized
    // new FsLightbox();
  }
}
